import React, { Component } from 'react'
import { NavLink } from 'react-router-dom'
import { Dropdown, Sidebar, Segment } from 'semantic-ui-react'

import TopMenu from './TopMenu.js'
import LeftMenu from './LeftMenu.js'
import Footer from './Footer.js'
import CurrentCards from './CurrentCards'

class Home extends Component {

  constructor (props) {
    super(props)
    this.mql = window.matchMedia && window.matchMedia(`(min-width: 768px)`)
    this.state = {
      left_menu_visible: false,
      is_narrow: false,
    }
    this.media_query_changed = this.media_query_changed.bind(this)
    this.toggle_left_menu = this.toggle_left_menu.bind(this)
    this.handle_left_menu_hide = this.handle_left_menu_hide.bind(this)
  }

  toggle_left_menu() {
    const { left_menu_visible } = this.state
    this.setState({left_menu_visible: !left_menu_visible })
  }
  handle_left_menu_hide() {
    const { is_narrow } = this.state
    if (is_narrow) {
      // close on background-tap in overlay / narrow mode only
      this.setState({left_menu_visible: false })
    }
  }

  componentDidMount() {
    this.mql && this.setState({
      left_menu_visible: this.mql.matches,
      is_narrow: !this.mql.matches,
    });
  }

  componentWillMount() {
    this.mql && this.mql.addListener(this.media_query_changed);
   }

  componentWillUnmount() {
    this.mql && this.mql.removeListener(this.media_query_changed);
  }

  media_query_changed() {
    if (this.mql) {
      console.log("mq changed", this.mql.matches);
      this.setState({
        left_menu_visible: this.mql.matches,
        is_narrow: !this.mql.matches
      });
    }
  }

  render () {
    const {
      userInfo,
      lang,
      preferences,
      onChangeLanguage,
      aufschaltung,
      aufschaltungen } = this.props

    const { left_menu_visible, is_narrow } = this.state

    return (
      <div className={`App ${is_narrow ? 'is-narrow' : ''}`}>
        <TopMenu userInfo={userInfo} lang={lang} onChangeLanguage={onChangeLanguage} onToggleMenu={this.toggle_left_menu} />
        <div className='App-main-below-menu' >

        <Sidebar.Pushable as={Segment}>
         <Sidebar animation='overlay' vertical visible={left_menu_visible} width='thin' onHide={this.handle_left_menu_hide} >
             <LeftMenu userInfo={userInfo} aufschaltung={aufschaltung} />
         </Sidebar>
         <Sidebar.Pusher>

          <div className={`App-main-content ${left_menu_visible ? 'menu-visible' : ''} `}>

            { (aufschaltungen && aufschaltungen.length > 1) ? (
              <span className='App-main-inline-menu-aufschaltungen'>
                <span className='label-aufschaltung'>Aufschaltung</span>
                <Dropdown inline key={aufschaltung.id} text={aufschaltung.title}>
                  <Dropdown.Menu>
                    { aufschaltungen.map((au, i) => (
                      <Dropdown.Item key={i}
                        icon={aufschaltung.id === au.id ? 'checkmark' : ''}
                        text={au.title}
                        as={NavLink} exact to={`/aufschaltung/${au.id}`} />
                    )) }
                  </Dropdown.Menu>
                </Dropdown>
              </span>
            ) : null }

            <CurrentCards aufschaltung={aufschaltung} userInfo={userInfo}
              lang={lang} preferences={preferences} />

          </div>

        </Sidebar.Pusher>
       </Sidebar.Pushable>

       </div>
       <Footer></Footer>
     </div>
    )
  }
}

export default Home



// WEBPACK FOOTER //
// ./src/components/Home.js